module.exports = __webpack_public_path__ + "static/media/FW_Block.ec23998b.jpg";